// import { ImagePreview } from 'vant'
import {
  queryCompetition, queryTerritoryData, queryTimeList, queryArgsToId,
  queryIdToArgs
} from '../../api/index.js'
import axios from 'axios'
import merge from 'webpack-merge'
export default {
  name: 'qn-detail-page',
  data () {
    return {
      currentPage: 1,
      allPage: 1,
      dataList: [],
      loading: false,
      finished: false,
      scrollTop: 0,
      time: null,
      scrollToptitle: '',
      peopleList: [{ name: '全部', value: null }, { name: '小学生', value: 1 }, { name: '初中生', value: 2 }, { name: '高中生', value: 3 }, { name: '大学生', value: 4 }],
      imgBig: '',
      imgBigShow: false,
      searchName: '',
      tabActive: { name: '全部', id: 0 },
      tabActiveDialog: null,
      territoryDataList: [
        {
          name: '学科分类',
          id: 3
        }, {
          name: '开课时间',
          id: 1
        },
        {
          name: '年级',
          id: 2
        }

      ],
      timeList: [],
      dialogCheckData1: [],
      dialogCheckData3: { name: '全部', value: null },
      dialogCheckData2: { name: '全部', id: 0 },
      subjecList: [{ name: '全部', id: 0 }]
    }
  },
  watch: {
    scrollTop: function (newVal, oldVal) {
      if (this.dataList.length) {
        if (newVal > 330) {
          this.$nextTick(() => {
            this.scrollToptitle = this.dataList[Math.floor((newVal / 240))].level2
          })
        } else {
          this.scrollToptitle = this.dataList[0].level2
        }
      }
    }
  },
  created () {
    this.getTimeList()
    this.getTerritoryData()
    this.setWXShareInfo()
  },
  mounted () {
    const that = this
    window.addEventListener('scroll', function () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
    }, true)
  },
  methods: {
    // 样式换行
    getLine (index) {
      this.$nextTick(() => {
        const noticeDom = this.$refs[index][0]
        const notice1 = noticeDom.parentNode.nextSibling.firstElementChild
        const style = window.getComputedStyle(noticeDom, null)
        const style1 = window.getComputedStyle(notice1, null)
        const row = Math.floor(
          Number(style.height.replace('px', '')) /
          Number(style.lineHeight.replace('px', ''))
        )
        const row1 = Math.floor(
          Number(style1.height.replace('px', '')) /
          Number(style1.lineHeight.replace('px', ''))
        )
        if (row >= 4) {
          noticeDom.style.cssText = 'line-clamp:4;-webkit-line-clamp:4'
          notice1.style.cssText = 'line-clamp:2;-webkit-line-clamp:2'
        }
        if (row1 > 3) {
          notice1.style.cssText = 'line-clamp:3;-webkit-line-clamp:3'
        }
      })
    },
    clicktab (item) {
      this.tabActive = item
      this.tabActiveDialog = item
    },
    querySure () {
      this.closeOverlay()
      this.searchInput()
    },
    searchInput () {
      clearTimeout(this.time)
      this.time = setTimeout(async () => {
        this.loading = true
        this.currentPage = 1
        this.list = []
        this.dataList = []
        this.finished = false
        this.getAllDataOnSearch(1)
      }, 800)
    },
    async getTerritoryData () {
      const result = await queryTerritoryData({})
      this.subjecList = [...this.subjecList, ...JSON.parse(JSON.stringify(result.data.competitionDirection))]
    },
    async getAllDataOnSearch (type) {
      const args = await this.getArgs(type)
      await this.onLoad(args)
    },
    async getArgs (type) {
      const args = {
        page: this.currentPage,
        limit: 20,
        add7Day: true,
        suggestGrade: this.dialogCheckData3.value === 1,
        suggestMiddle: this.dialogCheckData3.value === 2,
        suggestSenior: this.dialogCheckData3.value === 3,
        suggestCollege: this.dialogCheckData3.value === 4,
        time: this.dialogCheckData1,
        levelList: !this.dialogCheckData2 || (this.dialogCheckData2 && this.dialogCheckData2.id === 0) ? [] : [this.dialogCheckData2],
        name: this.searchName
      }
      // 如果没有ID去换取ID 如果是搜索时候要重新获取id
      if (!this.$route.query.id || type === 1 || this.currentPage !== 1) {
        args.page = 1 // 传入后台1
        const result = await queryArgsToId({ args: args })
        this.$router.replace({ query: merge(this.$route.query, { id: result.data.id }) })
        // 调用列表数据传正常
        args.page = this.currentPage
        return args
      } else if (this.$route.query.id) {
        // const idRes = await queryArgsToId({ args: args })
        // this.$router.replace({ query: merge(this.$route.query, { id: idRes.data.id }) })
        const result = await queryIdToArgs({ id: this.$route.query.id })
        // 第一次记录的参数
        if (result && result.data && result.data.args) {
          this.searchName = result.data.args.name
          this.initData(result.data.args)
          return result.data.args
        } else {
          return args
        }
      }
    },
    async initData (myargsObj) {
      // 如果是从连接跳转过来的有搜索默认数据
      if (myargsObj.page) {
        this.currentPage = myargsObj.page
      }
      this.add7Day = true
      if (myargsObj.name) {
        this.searchName = myargsObj.name
      }
      if (myargsObj.suggestGrade) {
        this.dialogCheckData3 = this.peopleList[1]
      } else if (myargsObj.suggestMiddle) {
        this.dialogCheckData3 = this.peopleList[2]
      } else if (myargsObj.suggestSenior) {
        this.dialogCheckData3 = this.peopleList[3]
      } else if (myargsObj.suggestCollege) {
        this.dialogCheckData3 = this.peopleList[4]
      } else {
        this.dialogCheckData3 = this.peopleList[0]
      }
      if (myargsObj.levelList && myargsObj.levelList.length) {
        this.dialogCheckData2 = myargsObj.levelList[0]
      }
      if (myargsObj.time && myargsObj.time.length) {
        this.dialogCheckData1 = myargsObj.time
      }
    },
    async initOnLoad () {
      const args = await this.getArgs()
      await this.onLoad(args)
    },
    async onLoad (args) { // 异步更新数据
      clearTimeout(this.time)
      this.time = setTimeout(async () => {
        // suggestSenior: BOOLEAN, // 是否建议高中生学习
        // suggestCollege: BOOLEAN, // 是否建议大学生学习
        // suggestMaster: BOOLEAN, // 是否建议硕士学习
        // suggestMiddle: BOOLEAN, // 是否建议初中学习 20220728
        // suggestGrade: BOOLEAN, // 是小学生
        const list = await queryCompetition(args)
        if (list.data.courseList.length === 0) {
          this.finished = true
          return
        }
        if (list.data.courseList.length > 0) {
          this.dataList = [...this.dataList, ...list.data.courseList]
        }
        this.allPage = list.data.allPage
        this.currentPage += 1
        this.loading = false
      }, 800)
    },
    godetail (item) {
      if (item.isCanGoInfo) {
        const origin = window.location.origin
        if (process.env.NODE_ENV === 'development') {
          window.open('https://sou-m-testserver.gecacademy.cn/share?id=' + item.id)
        } else {
          if (origin.indexOf('-testserver') > -1) {
            window.open('https://sou-m-testserver.gecacademy.cn/share?id=' + item.id)
          } else {
            window.open('https://sou-m.gecacademy.cn/share?id=' + item.id)
          }
        }
      }
    },
    // 查看图片
    show_before_img (item) {
      this.imgBig = item
      this.imgBigShow = true
      // ImagePreview({
      //   images: [item],
      //   showIndex: false,
      //   closeOnPopstate: true,
      //   closeable: true
      // })
    },
    closeImgBig () {
      this.imgBig = ''
      this.imgBigShow = false
    },
    async getTimeList () {
      const timeList = await queryTimeList({ })
      this.timeList = timeList.data
    },
    async clickDialog1 (item1, item) {
      const typeitem = item.year + '-' + item1
      const index = this.dialogCheckData1.findIndex(item1 => item1 === typeitem)
      if (index > -1) {
        this.dialogCheckData1.splice(index, 1)
      } else {
        this.dialogCheckData1.push(typeitem)
      }
    },
    async clickDialog3 (item) {
      this.dialogCheckData3 = item
    },
    async clickDialog2 (item) {
      this.dialogCheckData2 = item
    },
    async resetDialog (type) {
      // 重制路由内容
      if (type === 1) {
        this.dialogCheckData1 = []
      } else if (type === 2) {
        this.dialogCheckData3 = { name: '全部', value: null }
      } else {
        this.dialogCheckData2 = { name: '全部', id: 0 }
      }
      this.closeOverlay()
      this.dataList = []
      this.searchInput()
    },
    async closeOverlay () {
      this.tabActiveDialog = null
      this.tabActive = null
    },
    async setWXShareInfo () {
      const currentRouter = this.$router.currentRoute.fullPath
      const basehref = `https://sou-tools.gecacademy.cn${currentRouter}`
      const shareTitle = 'Path Academics'
      const shareDesc = 'Light Your Path. Walk Your Way.'
      // const shareImgUrl = 'https://gecacademy.oss-cn-beijing.aliyuncs.com/oa/smallSearch/share/share.jpeg'
      const shareImgUrl = 'https://gecacademy.oss-cn-beijing.aliyuncs.com/oa/upload/2021-04-30%2016-47-46-WechatIMG4292.jpeg'
      const shareInfo = {
        title: shareTitle,
        desc: shareDesc,
        link: basehref,
        imgUrl: shareImgUrl,
        success () {},
        cancel () {}
      }
      const test = Math.random()
      const timestamp = parseInt(new Date() / 1000)
      const params = {
        timestamp,
        noncestr: String(test),
        url: basehref,
        appName: 'sou-tools'
      }
      // const result = await axios.get('https://gec-api.gecacademy.cn/souapi/wechat/getSign', {
      //   params
      // })
      // const signature = result.data
      const result = await axios.post('https://gec-api.gecacademy.cn/souapi/wechat/sellTool/getSign', params)
      const signature = result.data.data.signature
      const wx = this.$wx
      await wx.configAsync({
        debug: false,
        appId: 'wxf88eda53c74e883f',
        timestamp,
        nonceStr: String(test),
        signature,
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage'
        ]
      })
      wx.onMenuShareTimeline(shareInfo)
      wx.onMenuShareAppMessage(shareInfo)
      wx.updateAppMessageShareData(shareInfo)
      wx.updateTimelineShareData(shareInfo)
    }
  }
}
